import { render, staticRenderFns } from "./AttributeMatchingListItem.vue?vue&type=template&id=520bb456&"
import script from "./AttributeMatchingListItem.vue?vue&type=script&lang=js&"
export * from "./AttributeMatchingListItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports